// src/components/blog/news_item.js

import Link from "next/link";
import React from "react";
import ReactHtmlParser from "html-react-parser";

const NewsItem = ({
  data,
  classes = "grid grid-cols-1 gap-[1.875rem] sm:grid-cols-2 md:grid-cols-3",
}) => {
  return (
    <div className={classes}>
      {data.map((item) => {
        const { id, mainImage, title, content, createdAt } = item;
        return (
          <article key={id}>
            <div className="rounded-2xl overflow-hidden transition-shadow hover:shadow-lg">
              <figure className="group max-h-96 overflow-hidden">
                <Link href={`/single_post/${id}`}>
                  <a>
                    <img
                      src={mainImage}
                      alt={title}
                      className="h-full w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105"
                    />
                  </a>
                </Link>
              </figure>

              {/* Body */}
              <div className="dark:border-jacarta-600 dark:bg-jacarta-700 border-jacarta-100 rounded-b-[1.25rem] border border-t-0 bg-white p-6">
                {/* Title */}
                <h2 className="font-display text-jacarta-700 dark:hover:text-green hover:text-green mb-4 text-xl dark:text-white">
                  <Link href={`/single_post/${id}`}>
                    <a>{title}</a>
                  </Link>
                </h2>
                {/* Excerpt */}
                <p className="dark:text-jacarta-200 mb-8">
                  {ReactHtmlParser(content.slice(0, 100) || "")}
                </p>

                {/* Date */}
                <div className="text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm">
                  <time>
                    {createdAt
                      ? new Date(createdAt.toDate()).toLocaleDateString()
                      : ""}
                  </time>
                </div>

                {/* View Detail Blog Button */}
                <div className="mt-4">
                  <Link href={`/single_post/${id}`}>
                    <a className="inline-block rounded bg-green py-2 px-4 text-sm font-semibold text-white hover:bg-green-dark">
                      View Detail Blog
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
};

export default NewsItem;
